export class Language {
  constructor(
    public key: string,
    public title: string,
    public isRTL: boolean,
  ) { }
}
